import { useState, useMemo } from 'react';

export const useCourseFilter = (courses) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDomain, setSelectedDomain] = useState('all');

  const filteredCourses = useMemo(() => {
    let filtered = courses;

    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(course =>
        course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course.domain.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by domain
    if (selectedDomain && selectedDomain !== 'all') {
      filtered = filtered.filter(course => course.domain === selectedDomain);
    }

    return filtered;
  }, [courses, searchTerm, selectedDomain]);

  return {
    searchTerm,
    setSearchTerm,
    selectedDomain,
    setSelectedDomain,
    filteredCourses,
  };
};